import React, {useState} from "react";
import '../processors/css/smartTriggerProcessors.css'
import {useSmartTriggerConfiguration} from "../../../context/smartTriggerConfigurationProvider";
import {findProcessorNode} from "../../../service/smartTriggerService";
import {SmartTriggerProcessorInput, SmartTriggerProcessorNodeConfiguration} from "../../../types";
import {Button, TextInput, Tooltip} from "@mantine/core";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleInfo, faPlus, faTrash} from "@fortawesome/free-solid-svg-icons";
import {CreateProcessorInputModal} from "./createProcessorInputModal";
import './smartTriggerProcessorInputsBox.css'
import {useStore} from "reactflow";


export function SmartTriggerProcessorInputsBox({nodeId}: { nodeId: string }) {
    const smartTriggerConfiguration = useSmartTriggerConfiguration();
    let currentNode;
    try {
        currentNode = findProcessorNode(nodeId, smartTriggerConfiguration.nodes);
    } catch (er) {
        currentNode = {data: {inputs: []}} as any as SmartTriggerProcessorNodeConfiguration;
    }


    const size = useStore(s => {
        const node = s.nodeInternals.get(nodeId as string);
        if (!node) {
            return;
        }
        return {
            positions: node.position,
            width: node.width,
            height: node.height,
        };
    });


    const [modalOpened, setModalOpened] = useState(false);

    function onNewInput(condition: SmartTriggerProcessorInput) {
        console.log(size)
        const node = findProcessorNode(nodeId, smartTriggerConfiguration.nodes)
        if (!node.data.inputs) {
            node.data.inputs = []
        }
        node.data.inputs.push(condition)
        smartTriggerConfiguration.updateNode(node)
        setModalOpened(false)
    }

    function onDelete(name: string) {
        const node = findProcessorNode(nodeId, smartTriggerConfiguration.nodes)
        if (!node.data.inputs) {
            node.data.inputs = []
        }
        node.data.inputs = node.data.inputs.filter(input => input.name !== name)
        smartTriggerConfiguration.updateNode(node)
    }


    return (<div className={"smart-trigger-processor-card-inputs"}>
        <div className={"smart-trigger-processor-card-inputs-header"}>
            <div>
                <label className={"smart-trigger-processor-card-inputs-header-label"}> SMART TRIGGER INPUTS</label>
            </div>
            <Button
                variant="default"
                onClick={() => setModalOpened(true)}
                color="gray" radius="xl"
                size="xs">
                <FontAwesomeIcon icon={faPlus} color={"teal"} size={"2x"}/>
            </Button>

            <CreateProcessorInputModal
                opened={modalOpened}
                onClose={() => setModalOpened(false)}
                onNewInput={(input) => onNewInput(input)}
            />
        </div>
        <div>
            {
                currentNode.data.inputs?.map(input => <InputGroup key={"input-group_" + input.name}
                                                                  onDelete={(name) => onDelete(name)} input={input}/>)
            }
        </div>

    </div>);
}

function InputGroup({
                        input,
                        onDelete
                    }: { input: SmartTriggerProcessorInput, onDelete: (name: string) => void }) {
    const defaultValue = input.defaultValue || `{input.${input.name}}`
    return (
        <div className={"smart-trigger-processor-input-group-row"}>
            <TextInput readOnly value={input.name}/>
            <TextInput readOnly value={defaultValue}/>
            <Tooltip
                wrapLines
                withArrow
                transition="fade"
                transitionDuration={200}
                label={input.description}
            >
                <FontAwesomeIcon className={"pointer blue"} icon={faCircleInfo}/>
            </Tooltip>
            <FontAwesomeIcon onClick={() => onDelete(input.name)} className={"pointer red"}
                             icon={faTrash}/>
        </div>
    )
}
